export const THEME_COLOR = {
  primary: '#00A4F2',
  purple: '#995EFC',
  slate: '#6575FF',
  aqua: '#29C3FF',
  turquoise: '#00BDB2',
  yellow: '#FFAA10',
  orange: '#FFAA10',
  tomato: '#F56428',
  gray: '#7C879B'
}



// WEBPACK FOOTER //
// ./packages/dof-panel/type.js